import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  variant?: 'default' | 'hover';
}

export default function Card({ children, className = '', onClick, variant = 'default' }: CardProps) {
  const { theme } = useTheme();

  const baseStyles = `
    rounded-xl overflow-hidden transition-all duration-200
    ${theme === 'dark' 
      ? 'bg-gray-800 shadow-lg shadow-gray-900/20'
      : 'bg-white shadow-md shadow-gray-200/50'
    }
  `;

  const hoverStyles = variant === 'hover' ? `
    ${theme === 'dark'
      ? 'hover:bg-gray-700/80 hover:shadow-lg hover:shadow-gray-900/30'
      : 'hover:shadow-lg hover:shadow-gray-200/50'
    }
  ` : '';

  return (
    <div
      onClick={onClick}
      className={`
        ${baseStyles}
        ${hoverStyles}
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
}